// SimpleExtraDetailsDisplay.tsx
import React from 'react';
import { Box, Typography, Grid, Chip, Alert } from '@mui/material';

interface SimpleExtraDetailsDisplayProps {
  extraDetails: string | Record<string, any>;
  serviceType?: string;
}

const ExtraDetailsDisplay: React.FC<SimpleExtraDetailsDisplayProps> = ({ 
  extraDetails, 
  serviceType 
}) => {
  
  // Parse the data
  let parsedData: Record<string, any> = {};
  
  try {
    if (typeof extraDetails === 'string') {
      parsedData = JSON.parse(extraDetails);
    } else if (typeof extraDetails === 'object' && extraDetails !== null) {
      parsedData = extraDetails;
    }
  } catch (error) {
    // If it's a string but not JSON, show it as-is
    if (typeof extraDetails === 'string') {
      return (
        <Box>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Additional Details
          </Typography>
          <Typography variant="body2">{extraDetails}</Typography>
        </Box>
      );
    }
  }
  
  if (!parsedData || Object.keys(parsedData).length === 0) {
    return null;
  }
  
  return (
        <Box className="my-1">
          
          <Grid container spacing={2}>
            {Object.entries(parsedData).map(([key, value]) => {
              if (value === null || value === undefined || value === '') return null;
              
              // Format the key for display
              const formattedKey = key
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, str => str.toUpperCase())
                .replace(/Id$/, 'ID')
                .replace(/(\d+)/, ' $1');
              
              return (
                <Grid item xs={12} sm={6} md={4} key={key}>
                  <Box
                    sx={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '12px',
                      p: 2,
                      backgroundColor: '#fafafa',
                    }}
                  >
                    <Typography 
                      variant="body2" 
                      sx={{ fontWeight: 600, mb: 1 }}
                      color="text.secondary"
                    >
                      {formattedKey}
                    </Typography>
                    <Chip
                      label={String(value)}
                      sx={{
                        backgroundColor: '#ffe6eb',
                        color: '#d6336c',
                        fontWeight: 500,
                        borderRadius: '8px',
                      }}
                    />
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
  );
};

export default ExtraDetailsDisplay;